import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";

const Profile = () => {
 
  return (
    <Container className="container py-5 h-100">
      <Row className="row d-flex justify-content-center align-items-center h-100">
        <Col className="col col-lg-9 col-xl-9">
        <Card className="rounded-top text-black d-flex flex-row" style={{backgroundColor: "#ecf2e7", height: "200px"}}>
          <Card style={{ width: '150px' }} className="ms-4 mt-5 d-flex flex-column">
            <Card.Img variant="bottom" src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-profiles/avatar-1.webp" />
          </Card>
          <div className="ms-3" style={{marginTop: "130px"}}>
              <h5>Andy Horwitz</h5>
              <p>New York</p>
          </div>

        </Card>
          <div className="p-4 text-black" style={{backgroundColor: "#f8f9fa"}}>
            <div className="d-flex justify-content-end text-center py-1">
              <div>
                <p className="mb-1 h5">Piano, Guitar</p>
                <p className="small text-muted mb-0">Instrument</p>
              </div>
              <div className="px-3">
                <p className="mb-1 h5">25 years</p>
                <p className="small text-muted mb-0">Experience</p>
              </div>
            </div>
          </div>

        <div className="card-body p-4 text-black">
            <div className="mb-5">
              <p className="lead fw-normal mb-1">About</p>
              <div className="p-4" style={{backgroundColor: "#f8f9fa"}}>
                <p className="font-italic mb-1">I’d like to take this opportunity to introduce myself. I was a 
                member of NVMTA 17 years ago, and now I am back in the DC
                area, having moved to Maryland two years ago. As a military
                spouse who's moved multiple times around the country and
                abroad, I have had to transfer my MTA state/local memberships
                to reflect my location. Despite our transient lifestyle, I have tried
                to attend meetings to keep inspired and contributed as much as
                possible to support the efforts of local associations. My membership in MTNA has really
                been my constant, through which I have been able to meet many wonderful teachers.
                For ten years prior to Air Force life, I had a private piano studio in Lincoln, Nebraska,
                where I attended graduate school. None of those experiences would have occurred
                without the many influences of teachers and graduate students that I met as an
                undergraduate at the University of Oklahoma. I feel blessed to have been surrounded
                by so many pedagogically-minded individuals who laid a rich foundation for me. And
                now, MCMTA has welcomed me.</p>
              </div>
            </div>
            {/* <div className="d-flex justify-content-between align-items-center mb-4">
              <p className="lead fw-normal mb-0">Recent photos</p>
              <p className="mb-0"><a href="#!" className="text-muted">Show all</a></p>
            </div> */}
            {/* <div className="row g-2">
              <div className="col mb-2">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Lightbox/Original/img%20(112).webp"
                  alt="image 1" className="w-100 rounded-3" />
              </div>
              <div className="col mb-2">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Lightbox/Original/img%20(107).webp"
                  alt="image 1" className="w-100 rounded-3" />
              </div>
            </div> */}
            {/* <div className="row g-2">
              <div className="col">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Lightbox/Original/img%20(108).webp"
                  alt="image 1" className="w-100 rounded-3" />
              </div>
              <div className="col">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Lightbox/Original/img%20(114).webp"
                  alt="image 1" className="w-100 rounded-3" />
              </div>
            </div> */}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Profile;
